import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Avatar, makeStyles, Typography } from '@material-ui/core';

const styleProfile = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1)
  },
  role: {
    marginTop: theme.spacing(1)
  }
}));

const Profile = props => {
  const { className, ...rest } = props;
  const classes = styleProfile();
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Avatar
        alt="Person"
        className={classes.avatar}
        component={RouterLink}
        src={props.avatar}
        to="/settings"
      />
      <Typography className={classes.name} variant="h4">
        {props.currentuser.name}
      </Typography>
      <Typography className={props.classes.role} variant="body2">
        {props.currentuser.roleDescription}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  avatar: PropTypes.string.isRequired,
  className: PropTypes.string,
  currentuser: PropTypes.object.isRequired
};

export default Profile;
